import { useEffect } from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { SecondaryButtonRouterLink } from 'components/Button';
import { Button } from 'components/Button/Button';
import ResumeDatabaseResponseContainer from 'containers/ResumeDatabaseResponseContainer';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { colors, fontWeights, gutterWidth } from 'theme';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { trackEventOnce } from 'utils/analytics/track/trackEventOnce';
import { getStaticImageSrc } from 'utils/getImageSrc';

const CloseButton = styled(Button)`
  opacity: 0.999; /* is invisible without this, why? */
`;

export function ResumeDatabaseBanner() {
  const { user } = useUserEnvironment();
  useEffect(() => {
    trackEventOnce('Displayed: Resume Database Ad', {
      context: 'Header Banner',
    });
  }, []);
  return (
    <Box
      data-qa-id="banner-ad"
      data-ad-type="resume-database"
      position="relative"
      zIndex={101}
      bg={colors.brandBlue}
      color="white"
      display="flex"
      py={12}
      pl={gutterWidth / 2}
      pr={gutterWidth / 2 - 16}
    >
      <Box
        position="absolute"
        left={0}
        top={0}
        width={1}
        height="100%"
        backgroundImage={`url('${getStaticImageSrc(
          'resume-database-banner.svg'
        )}')`}
        backgroundSize="cover"
        backgroundPosition="center"
      />
      <Box
        position="relative"
        minHeight={[160, 80, null, 92]}
        width={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap={['wrap', 'nowrap', null, null]}
      >
        <Box
          pr={[0, 10, null, null]}
          mt={['5px', 0, null, null]}
          mb={[2, 0, null, null]}
          fontSize={[16, null, null, 18]}
        >
          <Box
            display={['block', null, null, 'inline']}
            mb={['10px', null, null, 0]}
            mr="4px"
            fontWeight={fontWeights.semiBold}
          >
            {
              /* TRANSLATORS: Resume database promotional banner */
              getText('Welcome to Idealist!')
            }
          </Box>
          {
            /* TRANSLATORS: Resume database promotional banner */
            getText(`Let hiring managers know you're open to opportunities.`)
          }
        </Box>

        <Box display="flex" alignItems="center" flex="0 0 auto">
          <SecondaryButtonRouterLink
            to="/dashboard/employment-profile/get-discovered"
            reverse
            onClick={() => {
              trackClicked('Add Resume', {
                context: 'Banner',
              });
            }}
          >
            <Box minHeight={24} display="flex" alignItems="center">
              <Box display={['none', null, null, 'block']}>
                {user?.resumeId
                  ? getText('Share Your Resume')
                  : getText('Add Your Resume')}
              </Box>
              <Box display={['block', null, null, 'none']}>
                {user?.resumeId
                  ? getText('Share Resume')
                  : getText('Add Resume')}
              </Box>
            </Box>
          </SecondaryButtonRouterLink>
        </Box>
      </Box>
      <ResumeDatabaseResponseContainer>
        {({ dismiss }) => (
          <CloseButton
            data-qa-id="close-banner-ad-button"
            onClick={() => {
              dismiss();
              trackClicked('Dismiss Resume Database CTA', {
                context: 'Banner',
              });
            }}
            variant="legacy-tertiary-white"
            iconName="close"
          />
        )}
      </ResumeDatabaseResponseContainer>
    </Box>
  );
}
